import {DateIntervalType} from "../../../../gd/utils/datetime/interval";

export const Date_GroupingOptions: Option[] = [
    {
        value   : DateIntervalType.DAILY,
        label   : 'Daily'
    },
    {
        value   : DateIntervalType.WEEKLY,
        label   : 'Weekly'
    },
    {
        value   : DateIntervalType.BIWEEKLY,
        label   : 'Biweekly'
    },
    {
        value   : DateIntervalType.MONTHLY,
        label   : 'Monthly'
    },
    {
        value   : DateIntervalType.QUARTERLY,
        label   : 'Quarterly'
    },
    {
        value   : DateIntervalType.YEARLY,
        label   : 'Yearly'
    },
]